const   getIndicator = state => state.indicator;

export default {
    getIndicator,
};
